import BaseService from '../base'

export default class UserControllerBase extends BaseService {
  static readonly basePath = 'user/api/v1.0'
  private readonly controllerPath: string

  constructor(controllerPath: string) {
    super(UserControllerBase.basePath)
    this.controllerPath = controllerPath
  }

  protected getFullServiceUrl() {
    return `${this.getFullBaseUrl()}/${this.controllerPath}`
  }
}
